import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'eventType'
})
export class EventTypePipe implements PipeTransform {
  transform(eventType: string): string {
    if (!eventType) {
      return '';
    }
    return eventType.replace(/([A-Z])/g, ' $1').trim();
  }
} 